import type { BusinessShare } from 'types/group'
export const getSharedChannelBusinessRecipients = (
  businesses?: BusinessShare[],
): Array<string> | null => {
  if (!businesses) return null
  const filteredBusinesses = businesses
    .filter(business => business.status === 'accepted')
    .map(business => business.name)

  if (filteredBusinesses?.length > 0) {
    return filteredBusinesses
  }

  return null
}
